module.exports = __webpack_public_path__ + "img/icon-menu-news-situ1.3fcf47fa.png";